import { lazyGetM365Acquisition } from "../lazyFunction";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isAddinMultiAccountEnabled } from "owa-feature-flags";
import { M365AppId } from "../data/M365AppId";
import type { MailboxInfo } from "owa-client-types";

export async function getLogAppId(appId: string, mailboxInfo?: MailboxInfo): Promise<string> {
    let logAppId = appId;
    // if its a known appId, can be returned as is
    if (Object.values(M365AppId).includes(appId)) {
        return logAppId;
    }
    const scope = await getAcquisitionScope(appId, mailboxInfo);
    logAppId = scope === "Public" ? appId : `3rdPartyApp-${scope}`;
    return logAppId;
}

async function getAcquisitionScope(appId: string, mailboxInfo?: MailboxInfo): Promise<string> {
    const currMailboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    const { acquisition } = await lazyGetM365Acquisition.importAndExecute(appId, "cache-only", isAddinMultiAccountEnabled() ? currMailboxInfo : undefined);
    return acquisition?.titleDefinition.scope ?? "unknown";
}
